import { FC, Fragment, useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import {
  populateGridColumns,
  getUserRole,
  getUserSession,
  readGridConfig,
  getPageNumberFromSession,
  getRuleValidationMessage,
  getEntityDataFromSession,
  getUserMainRole,
} from "../../components/shared/common/util";
import { GridType } from "../../models/GridType";
import "../../content/styles/AddCaseGrid.css";
import DashboardGrid from "../../components/shared/grid/dashboardgrid";
import { IGridProps } from "../../components/shared/grid/IGridProps";
import { DealType } from "../../models/DealType";
import { IDashboardDataRequest } from "../../models/IDashboardDataRequest";
import { nextGenService } from "../../services/NextGenService";
import {
  Stack,
  Spinner,
  MessageBarType,
  CommandBarButton,
  FontIcon,
  MessageBar,
  IconButton,
} from "office-ui-fabric-react";
import { UIControlsText } from "../../content/UIControlsText";
import { JavaScriptExtensions } from "../../infrastructure/JavaScriptExtensions";
import { IDashboardGridProps } from "./props/IDashboardGridProps";
import { unionBy } from "lodash";
import { IOpportunityDealDetails } from "../../models/IOpportunityDealDetails";
import { filterBy } from "@progress/kendo-data-query";
import { CssClassConstants } from "../../content/CssClassConstants";
import { UserSubRole } from "../../models/UserSubRole";
import { RefreshButtonStyles, _Styles } from "../../content/styles/Page.styles";
import { PageConstants } from "../pageconstants/Constants";
import { announceToScreenReader } from "../../hooks/accessiblity-hooks";
import Row from "react-bootstrap/esm/Row";
import { AddToCase } from "./add-to-case";
import { MessageTypeText } from "../../models/MessageTypeText";
import { SessionStorageConsts } from "../../models/SessionStorageConsts";
import { DashboardSearch } from "./dashboard-search";
import { IAccount } from "../../models/IAccount";
import moment from "moment";

// Set once at module level so JSON.stringify serializes Dates via moment
Date.prototype.toJSON = function () { return moment(this).format(); };

export const OneTimeLocalEmpowerment: FC<IDashboardGridProps> = (
  props: IDashboardGridProps,
) => {
  const history = useHistory();
  const sessionResourceData = getEntityDataFromSession<any>(
    SessionStorageConsts.resourceStrings,
  );
  const [oneTimeLocalEmpowerment, setOneTimeLocalEmpowerment] =
    useState<IGridProps>(readGridConfig(GridType.OneTimeLocalEmpowerment));
  const [isCaseLoading, setIsCaseLoading] = useState<boolean>(false);
  const [isRefreshed, setIsRefreshed] = useState<boolean>(false);
  // Accessibility (WCAG 4.1.3): tracks a user-initiated refresh so completion is announced once.
  const isRefreshAnnouncementPending = useRef<boolean>(false);
  const [pageNumber, setpageNumber] = useState<number>(1);
  const [userRoles] = useState<string>(getUserRole());
  const [otleData, setOtleData] = useState<IOpportunityDealDetails[]>([]);
  const [sqlRecordCount, setSqlRecordCount] = useState<number>(0);
  const [msgBarText, setMsgBarText] = useState<string>();
  const [filteredPartnerAccount, setfilteredPartnerAccount] = useState<
    IAccount[] | undefined
  >(undefined);
  const [hideDialog, setHideDialog] = useState<boolean>(true);
  const [errorMessageType, setErrorMessageType] = useState(
    MessageBarType.success,
  );
  const [showMessageBarOnDashboard, setshowMessageBarOnDashboard] =
    useState<boolean>(false);
  const resetDashboardMessageBarChoice = useCallback(
    () => setshowMessageBarOnDashboard(false),
    [],
  );
  const [gridDataState, setGridDataState] = useState<any>();

  useEffect(() => {
    oneTimeLocalEmpowerment.kendoGridProps = populateGridColumns(
      oneTimeLocalEmpowerment.kendoGridProps,
    );
    oneTimeLocalEmpowerment.kendoGridProps.noOfRecords =
      getPageNumberFromSession(oneTimeLocalEmpowerment.kendoGridProps);
    setOneTimeLocalEmpowerment(oneTimeLocalEmpowerment);
    const hasSavedPartners = (() => {
      try {
        const s = sessionStorage.getItem(`dashboardSearchState:${window.location.pathname}`);
        if (!s) return false;
        const p = JSON.parse(s);
        return !!(p?.selectedADDAccountId || p?.selectedResellerAccountId);
      } catch { return false; }
    })();
    if (!hasSavedPartners) {
      getOTLECases(pageNumber);
    }
  }, []);

  useEffect(() => {
    if (props.onAddToCaseCallBack === GridType.OneTimeLocalEmpowerment) {
      getOTLECases(1);
    }
  }, [props.onAddToCaseCallBack]);

  useEffect(() => {
    if (isRefreshed) {
      onRefresh();
    }
  }, [isRefreshed]);

  // Accessibility (WCAG 4.1.3): announce completion once the refreshed cases finish loading.
  useEffect(() => {
    if (!isCaseLoading && isRefreshAnnouncementPending.current) {
      isRefreshAnnouncementPending.current = false;
      announceToScreenReader(PageConstants.CasesRefreshedAnnouncement, "polite");
    }
  }, [isCaseLoading]);

  useEffect(() => {
    if (otleData.length == 0 && isRefreshed) {
      setIsRefreshed(false);
      setSqlRecordCount(0);
      setpageNumber(1);
      getOTLECases(1, gridDataState);
    }
  }, [otleData]);

  useEffect(() => {
    if (filteredPartnerAccount != undefined) {
      setIsRefreshed(true);
    }
  }, [filteredPartnerAccount]);

  const getOTLECases = async (
    pageNo?: number,
    dataState?: any,
    pageChanged?: boolean,
  ) => {
    try {
      setIsRefreshed(false);
      const userSession = getUserSession();
      setIsCaseLoading(true);
      let loggedInUserInfo = JSON.parse(userSession);
      let roles = userRoles.split(",");
      let sort: any;
      let filter: any;
      var searchedCaseNumber = "";
      if (!JavaScriptExtensions.isNullOrUndfinedOrEmpty(dataState)) {
        if (
          dataState.sort[0] &&
          !JavaScriptExtensions.isEmptyOrNullOrUndefined(
            dataState.sort[0].field,
          )
        ) {
          sort = dataState.sort[0].field + " " + dataState.sort[0].dir;
        }
        filter = JSON.stringify(dataState.filter);
        searchedCaseNumber =
          dataState?.filter?.filters[0]?.filters[0]?.field === "opportunityName"
            ? dataState.filter.filters[0].filters[0].value
            : "";
      }
      var resellerOrDistributorFilters: IAccount[] = [];
      if (
        filteredPartnerAccount != undefined &&
        filteredPartnerAccount.length != 0
      ) {
        resellerOrDistributorFilters = filteredPartnerAccount;
      }
      const dashboardRequest: IDashboardDataRequest = {
        userRoleDetails: loggedInUserInfo.userRoleDetails,
        dealType: DealType.OTLE,
        email: loggedInUserInfo.email,
        userRoles: roles.join(","),
        filter: filter,
        pageNumber: pageNo,
        recordsToFetch: oneTimeLocalEmpowerment.kendoGridProps.recordsToFetch,
        sort: sort,
        isAllCasesDashboardRequest: false,
        isLocalEmpowerment: false,
        organizationId: loggedInUserInfo.organizationId,
        resellerOrDistributorFilters: resellerOrDistributorFilters,
      };
      if (
        otleData.filter((dt) => dt.opportunityName === searchedCaseNumber)
          .length == 0
      ) {
        let apiReturnedData = await nextGenService.getPricingProgramDashboardData(dashboardRequest);
        if (apiReturnedData.status === 200) {
          apiReturnedData.data.item1 = apiReturnedData.data.item1.map(
            (item: IOpportunityDealDetails) => ({
              ...item,
              expirationDate: JavaScriptExtensions.isNullOrUndfinedOrEmpty(
                item.expirationDate,
              )
                ? item.expirationDate
                : new Date(item.expirationDate as Date),
              caseStartDate: JavaScriptExtensions.isNullOrUndfinedOrEmpty(
                item.caseStartDate,
              )
                ? item.caseStartDate
                : new Date(item.caseStartDate as Date),
            }),
          );
          let otleConfig = { ...oneTimeLocalEmpowerment };
          var finalData: IOpportunityDealDetails[];
          if (pageChanged === undefined || pageChanged === false) {
            finalData = apiReturnedData.data.item1;
          } else {
            finalData = [...apiReturnedData.data.item1, ...otleData];
          }
          finalData = unionBy(finalData, (x) => x.id);
          otleConfig.kendoGridProps.data = finalData;
          setOtleData(finalData);
          otleConfig.kendoGridProps.totalRecords = finalData.length;
          setOneTimeLocalEmpowerment(otleConfig);
          setSqlRecordCount(
            apiReturnedData.data.item2.OtleDeals + sqlRecordCount,
          );
        } else if (apiReturnedData.status === 403) {
          const apiMessage = apiReturnedData.data as any;
          const message =
            (typeof apiMessage === "string" && apiMessage) ||
            getRuleValidationMessage(
              sessionResourceData,
              MessageTypeText.OpportunityValidationError,
              "UnauthorizedMessage",
              UIControlsText.UnauthorizedMessage,
            );
          history.push({
            pathname: "/errorPage",
            state: { message },
          });
        }
      }
      oneTimeLocalEmpowerment.kendoGridProps.customGridMessage =
        getRuleValidationMessage(
          sessionResourceData,
          MessageTypeText.OpportunityValidationError,
          "NoRecordsFound",
          UIControlsText.NoRecordsFound,
        );
      setIsCaseLoading(false);
    } catch (error) {
      setIsCaseLoading(false);
    }
  };

  const onGetDataRequest = (
    dataState: any,
    isSortingOrFilterAppliedOrRemoved?: boolean,
  ) => {
    setGridDataState(dataState);
    if (
      filterBy(otleData || [], dataState.filter).length - dataState.skip <=
        dataState.take ||
      isSortingOrFilterAppliedOrRemoved === true
    ) {
      var pageNo =
        !isSortingOrFilterAppliedOrRemoved &&
        isSortingOrFilterAppliedOrRemoved !== undefined &&
        isSortingOrFilterAppliedOrRemoved !== null
          ? pageNumber + 1
          : 1;
      if (
        !isSortingOrFilterAppliedOrRemoved &&
        isSortingOrFilterAppliedOrRemoved !== undefined &&
        isSortingOrFilterAppliedOrRemoved !== null
      ) {
        setpageNumber((count) => count + 1);
      } else {
        setpageNumber(1);
      }
      getOTLECases(pageNo, dataState, !isSortingOrFilterAppliedOrRemoved);
    }
  };

  function addCase() {
    return !userRoles.includes(UserSubRole.ADD) ? (
      ""
    ) : (
      <CommandBarButton
        onClick={() => {
          setHideDialog(false);
        }}
      >
        <div className={_Styles.CommandBarButton}>
          <FontIcon
            className={_Styles.DashboardIcons}
            aria-label={getRuleValidationMessage(
              sessionResourceData,
              MessageTypeText.FieldLabelText,
              "AddCaseAriaLabel",
              UIControlsText.AddCaseAriaLabel,
            )}
            iconName={CssClassConstants.CirclePlusIconName}
          ></FontIcon>
          <span className={_Styles.DashboardBtnText}>
            {PageConstants.AddCasToDashboard}
          </span>
        </div>
      </CommandBarButton>
    );
  }

  const initiateRefresh = () => {
    // Accessibility (WCAG 4.1.3): announce refresh start so NVDA reports the status change.
    isRefreshAnnouncementPending.current = true;
    announceToScreenReader(PageConstants.LoadingCasesAnnouncement, "polite");
    setIsRefreshed(true);
  };

  const onRefresh = () => {
    if (isRefreshed) {
      let otleConfig = { ...oneTimeLocalEmpowerment };
      otleConfig.kendoGridProps.isRefresh = true;
      otleConfig.kendoGridProps.data = [];
      otleConfig.kendoGridProps = populateGridColumns(
        otleConfig.kendoGridProps,
      );
      otleConfig.kendoGridProps.noOfRecords = getPageNumberFromSession(
        otleConfig.kendoGridProps,
      );
      setOneTimeLocalEmpowerment(otleConfig);
      otleConfig.kendoGridProps.customGridMessage = "";
      setOtleData([]);
    }
  };

  const onfilterByPartner = (account: IAccount[] | undefined) => {
    setfilteredPartnerAccount(account);
  };

  const onSuccess = (
    showMessageBar: boolean,
    messageType: any,
    messageText: string,
    isReloadData: boolean,
    resetHideDialog: boolean,
  ): void => {
    if (resetHideDialog) {
      setHideDialog(resetHideDialog);
    }

    if (showMessageBar) {
      setErrorMessageType(messageType);
      setMsgBarText(messageText);
      setshowMessageBarOnDashboard(true);
    }
    if (isReloadData) {
      setIsRefreshed(true);
    }
  };

  function addRefreshIcon() {
    return (
      <CommandBarButton
        onClick={initiateRefresh}
        iconProps={{ iconName: CssClassConstants.RefreshIconName }}
        ariaLabel={CssClassConstants.RefreshIconName}
        title="Refresh"
        styles={RefreshButtonStyles}
      >
        <span className={_Styles.DashboardBtnText}>
          {PageConstants.Refresh}
        </span>
      </CommandBarButton>
    );
  }

  return (
    <Fragment>
      {!userRoles.includes(UserSubRole.ADD) ? (
        <div id="RefreshIconButton" className={_Styles.CommandBarButton}>
          {addRefreshIcon()}
        </div>
      ) : (
        <div id="RefreshButton" className={_Styles.CommandBarButton}>
          {addRefreshIcon()}
        </div>
      )}
      <div className={CssClassConstants.AddToCaseButtonClass}>{addCase()}</div>
      <Stack>
        {userRoles.includes(UserSubRole.ADD) && (
          <Row className="text-center mt-2 ms-Label">
            <Stack>
              <DashboardSearch {...{ onfilterByPartner: onfilterByPartner }} />
            </Stack>
          </Row>
        )}
        <Row>
          {showMessageBarOnDashboard && (
            <Stack>
              <div>
                <MessageBar
                  messageBarType={errorMessageType}
                  onDismiss={resetDashboardMessageBarChoice}
                  dismissButtonAriaLabel="Close"
                  isMultiline={true}
                >
                  {msgBarText}
                </MessageBar>
              </div>
            </Stack>
          )}
        </Row>
        {isCaseLoading && (
          <Stack>
            <div>
              <Spinner
                label={getRuleValidationMessage(
                  sessionResourceData,
                  MessageTypeText.FieldLabelText,
                  "LoadingCases",
                  UIControlsText.LoadingCases,
                )}
              />
            </div>
          </Stack>
        )}
        <DashboardGrid
          {...{
            kendoGridProps: { ...oneTimeLocalEmpowerment.kendoGridProps },
            onGetDataRequest: onGetDataRequest,
            resellerOrDistributorFilters: filteredPartnerAccount,
          }}
        />
        <div id="footerPadding"></div>
      </Stack>
      {/* Add Case Model */}
      <AddToCase {...{ hideDialog: hideDialog, onSuccess }} />
    </Fragment>
  );
};
